import { render, staticRenderFns } from "./AdminPlusNavItem.vue?vue&type=template&id=7a4ac413&scoped=true"
import script from "./AdminPlusNavItem.vue?vue&type=script&lang=js"
export * from "./AdminPlusNavItem.vue?vue&type=script&lang=js"
import style0 from "./AdminPlusNavItem.vue?vue&type=style&index=0&id=7a4ac413&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a4ac413",
  null
  
)

export default component.exports